<template>
  <div>
    <!-- <div class="header">
      <h1>Chania</h1>
    </div> -->
    <div class="row">
      <div class="col-2">
        <section>
          <!-- <b-button @click="showAdvancedBodyEditor()">
            Acceder a editor para expertos</b-button
          >
          <hr />
          <h4>Editor básico</h4> -->
          <b-field :label="$t('Título del evento')" style="color:#fff;">
            <b-input
              v-model="title"
              :placeholder="$t('Título del evento')"
            ></b-input>
          </b-field>
          <b-field :label="$t('Fecha inicial')">
            <b-datepicker
              v-model="start_date"
              :show-week-number="false"
              :locale="this.$i18n.locale"
              trap-focus
              :first-day-of-week="1"
            >
            </b-datepicker>
          </b-field>
          <b-field :label="$t('Fecha final')">
            <b-datepicker
              v-model="end_date"
              :show-week-number="false"
              :locale="this.$i18n.locale"
              trap-focus
              :first-day-of-week="1"
            >
            </b-datepicker>
          </b-field>
          <b-field :label="$t('Cuerpo del evento')" style="color:#fff;">
            <b-input
              v-model="body"
              :placeholder="$t('Cuerpo del evento')"
              type="textarea"
            ></b-input>
          </b-field>
          <b-field :label="$t('Añade unas imágenes del producto')">
            <b-upload v-model="dropFiles" multiple drag-drop>
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large"> </b-icon>
                  </p>
                  <p>
                    {{
                      $t('Arrastra aquí las imágenes o pulsa para selccionar')
                    }}
                  </p>
                </div>
              </section>
            </b-upload>
          </b-field>

          <div class="tags">
            <span
              v-for="(file, index) in dropFiles"
              :key="index"
              class="tag is-primary"
            >
              {{ file.name }}
              <button
                class="delete is-small"
                type="button"
                @click="deleteDropFile(index)"
              ></button>
            </span>
          </div>
        </section>
        <b-button @click="publishEvent()">{{ $t('Publicar Evento') }}</b-button>
      </div>

      <div class="col-3 actions">
        <h4>{{ $t('Previsualización del evento') }}</h4>
        <hr />
        <div class="aside">
          <div v-if="dropFiles.length > 0">
            <img :src="fileToImage(dropFiles[0])" />
          </div>
          <h3>{{ title }}</h3>
          <p v-html="body"></p>
        </div>

        <div class="menu right">
          <!-- <ul>
            <li style="background-color: #717a81; color:#fff;">
              <div @click="createNews()">
                <h6>Publicar nueva noticia</h6>
                <p>Publica una nueva noticia en tu club</p>
              </div>
            </li>
            <li style="background-color: #ed6a5a; color:#fff">
              <h6>Eliminar noticia</h6>
            </li>
          </ul> -->
        </div>
      </div>
    </div>

    <!-- <div class="footer">
      <p>
        Resize the browser window to see how the content respond to the
        resizing.
      </p>
    </div> -->
  </div>
</template>

<script>
import { InitViewMixin } from '@/mixins/InitViewMixin.js'

export default {
  data() {
    return {
      dropFiles: [],
      title: '',
      body: '',
      start_date: new Date(),
      end_date: new Date(new Date().setDate(new Date().getDate() + 1)),
      locale: 'es-ES',
      images: []
    }
  },
  mixins: [InitViewMixin],
  methods: {
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1)
    },
    showAdvancedBodyEditor() {
      this.$router.push({ name: 'htmleditor' })
    },
    fileToImage(file) {
      return URL.createObjectURL(file)
    },
    publishEvent() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      this.$store
        .dispatch('events/postEvent', {
          association: this.currentClub.nid,
          title: this.title,
          body: this.body,
          start_date: Date.parse(this.start_date) / 1000,
          end_date: Date.parse(this.end_date) / 1000,
          // urls: [
          //   { url: 'https://google.com', title: 'Google' },
          //   { url: 'https://duckduckgo.com', title: 'DuckDuckGo' }
          // ],
          images: this.images
        })
        .then(response => {
          // commit(SET_USERS, response.data)
          console.log(response)
          loadingComponent.close()
          this.$router.push({ name: 'events' })
        })
        .catch(error => {
          tools.manageAxiosError(error)
          console.log('Ha habido un error:' + error)
        })
    }
  },
  created() {
    this.validateAccess(['comunicacion'])
  },
  watch: {
    currentClub() {
      this.validateAccess(['comunicacion'])
    },
    dropFiles() {
      this.dropFiles.forEach(file => {
        const comp = this
        function readerOnload(e) {
          var base64 = btoa(e.target.result)
          comp.images.push(base64)
        }
        var reader = new FileReader()
        reader.onload = readerOnload
        reader.readAsBinaryString(file)
      })
    }
    // dropFiles: function(o, n) {
    //   var reader = new FileReader()
    //   reader.onload = e => this.$emit('load', e.target.result)
    //   reader.readAsText(o[0]) // This line throws the error.
    //   alert()
    //   console.log(o)
    // }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.row::after {
  content: '';
  clear: both;
  // display: flex;
}

[class*='col-'] {
  float: left;
  padding: 15px;
}

html {
  font-family: 'Lucida Sans', sans-serif;
}

.my-table {
  // max-height: 100%;
  overflow-y: auto;
  height: calc(100vh - 150px);
  // height: 1000px;
}

.header {
  background-color: #9933cc;
  color: #ffffff;
  padding: 15px;
}

.menu ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  top: 10px;
  // height: 5vh;
  overflow: auto;
}

.menu li {
  padding: 8px;
  margin-bottom: 7px;
  background-color: #f7f3f3;
  color: #666666;
  box-shadow: 0 1px 3px rgba(78, 78, 78, 0.12), 0 1px 2px rgba(71, 71, 71, 0.24);
  border-radius: 6px;
  cursor: pointer;
}

.right li {
  // background-color: #33b5e5;
  // color: #fff;
  background-color: #f3f3f3;
}

.left li {
  background-color: #f3f3f3;
  // color: #fff;
}

.menu li:hover {
  background-color: #e1e1e1;
  // color: #fff;
}

.aside {
  background-color: #f3f3f3;
  padding: 15px;
  color: #666666;
  text-align: center;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(78, 78, 78, 0.12), 0 1px 2px rgba(71, 71, 71, 0.24);
  border-radius: 6px;
}

.footer {
  background-color: #0099cc;
  color: #ffffff;
  text-align: center;
  font-size: 12px;
  padding: 15px;
}

/* For desktop: */

.col-2 {
  width: 60%;
  background-color: #f9f9f9;
  border-radius: 6px;
  height: 100vh;
}
.col-3 {
  width: 40%;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.consultsList {
  height: calc(100vh - 160px);
  overflow: auto;
}

.chat {
  height: calc(100vh - 190px);
  overflow: auto;
}

.actions {
  height: calc(100vh - 85px);
  overflow: auto;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  [class*='col-'] {
    width: 100%;
  }
}
</style>
